<template>
  <div class="refund-cancelation">
    <Retailnavbar> </Retailnavbar>

    <div class="main-page">
      <div class="section-1">Refund and Cancelation Policy</div>

     <RefundAndCancellationComponent></RefundAndCancellationComponent>
    </div>

    <RetailFooter></RetailFooter>
  </div>
</template>
<script>
import { screenSize } from "../../mixins/ScreenSize.js";
// import RetailFooter from "@/components/RetailSideCompo/RetailFooter.vue";
import RetailFooter from "@/components/RetailSideCompo/RetailFooter.vue";
import Retailnavbar from "@/components/RetailSideCompo/RetailNavbar.vue";
import RefundAndCancellationComponent from "@/components/RetailSideCompo/RefundAndCancellationComponent.vue";

export default {
  name: "AdvisorsRefundAndCancelation",

  components: {RefundAndCancellationComponent, RetailFooter, Retailnavbar },

  mixins: [screenSize],

  data() {
    return {
      // search_stock: "",
      // value2: 4,
      // colors: ["#99A9BF", "#F7BA2A", "#ffff"],
      // selectedCard: "marketSentiment",
      // marketSentimentData: [
      //   {
      //     heading: "",
      //   },
      // ],
    };
  },

  methods: {},

  computed: {},
};
</script>
<style lang="scss" scoped>
.refund-cancelation {
  background-color: #fcfcfb;
  .main-page {
    .section-1 {
       background-image: url("../../assets/images/ExpertLandingPage/footer/advisor/banner1.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      height: 400px;
      font-size: 2rem;
      font-weight: 600;
      text-transform: uppercase;
      color: #ffff;
      text-align: center;
      padding-top: 150px;
    }
    .section-2 {
      .special-sec {
        margin: 60px 0;
      }
      h1 {
        font-size: 1.6rem;
        font-weight: 600;
      }
      p {
        font-size: 0.9rem;
      }
      ul {
        list-style: none;
        li {
          font-size: 0.9rem;
          margin: 10px 0;
        }
        li::before {
          content: "\2022";
          color: #322e79;
          font-weight: bold;
          width: 1em;
          margin-left: -1em;
          font-size: 45px;
          position: relative;
          margin-right: 25px;
          top: 7px;
        }
      }
    }

    @media screen and (max-width: 876px) {
      .section-1 {
        height: 346px;
        font-size: 1.5rem;
      }
      .section-2 {
        padding: 0 70px;
      }
    }
    @media screen and (max-width: 600px) {
      .section-1 {
        height: 200px;
        padding-top: 80px;
        font-size: 1.2rem;
      }
      .section-2 {
        padding: 0 35px;
      }
    }
    @media screen and (max-width: 450px) {
      .section-1 {
        height: 134px;
      }
      .section-2 {
        padding: 0 20px;
      }
    }
  }
}
</style>


